import React from "react";

interface FieldWithAutoFillProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  suggestedValue?: string;
  type?: "input" | "textarea";
  rows?: number;
  required?: boolean;
}

export const FieldWithAutoFill: React.FC<FieldWithAutoFillProps> = ({
  value,
  onChange,
  placeholder,
  type = "input",
  rows = 4,
}) => {
  const baseClass =
    "w-full rounded-md border border-white/10 bg-white/5 px-4 py-3 text-white placeholder:text-white/30 focus:border-amber-400/50 focus:outline-none";

  if (type === "textarea") {
    return (
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        className={`${baseClass} resize-none`}
      />
    );
  }

  return (
    <input
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={baseClass}
    />
  );
};
